module.exports = __webpack_public_path__ + "static/media/move-down-white.902732be.svg";